var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import { TodoFooter } from './components/TodoFooter';
import { TodoHeader } from './components/TodoHeader';
import { TodoList } from './components/TodoList';
import './style.css';
var index = 0;
export var TodoApp = function () {
    var _a = useState({}), todos = _a[0], setTodos = _a[1];
    var _b = useState('all'), filter = _b[0], setFilter = _b[1];
    var _addTodo = function (label) {
        var _a;
        var id = index++;
        setTodos(__assign(__assign({}, todos), (_a = {}, _a[id] = { label: label, completed: false }, _a)));
    };
    var _complete = function (id) {
        var _a;
        var todo = todos[id];
        var newTodos = __assign(__assign({}, todos), (_a = {}, _a[id] = __assign(__assign({}, todo), { completed: !todo.completed }), _a));
        setTodos(newTodos);
    };
    var _clear = function () {
        var newTodos = {};
        Object.keys(todos).forEach(function (id) {
            if (!todos[id].completed) {
                newTodos[id] = todos[id];
            }
        });
        setTodos(newTodos);
    };
    var _setFilter = function (filter) {
        setFilter(filter);
    };
    return (React.createElement("div", null,
        React.createElement(TodoHeader, { addTodo: _addTodo, setFilter: _setFilter, filter: filter }),
        React.createElement(TodoList, { complete: _complete, todos: todos, filter: filter }),
        React.createElement(TodoFooter, { clear: _clear, todos: todos })));
};
